// import { VolumeControls } from '@hmpu/powerups.audio.components.volume-controls';
// import { OptionsMenu } from '@hmpu/powerups.ui.dialogs.settings';
import { GameControls as GameControlsPanel } from '../components/panels/GameControls';
import { HowToPlay as HowToPlayPanel } from '../components/panels/HowToPlay';
import { AccessibilitySettings as AccessibilitySettingsPanel } from '../components/panels/AccessibilitySettings';
// import { HowToPlay as HowToPlayPanel } from '../components/panels/HowToPlay';
import { VolumeControls } from "@hmpu/powerups.audio.components.volume-controls";
// import { OptionsMenu, AccessibilitySettings, GameControls } from "@hmpu/powerups.ui.dialogs.settings";
import { OptionsMenu, AccessibilitySettings, GameControls } from '../components/settings';
import Instructions from "./Instructions";
import Controls from "./controls";
import AccessibilityMenu from "./AccessibilityMenu";
import { isIOS } from '../services/isIOS';

import { LanguageSettings as LanguageSettingsPanel } from '../components/settings/panels/LanguageSettings';
import { getRegionLocaleLangs } from 'services/getRegionLocaleLangs';

export const SettingsPanelConfig = {
  root: {
    name: 'OptionsMenu',
    variant: 'panel',
    heading: { localeKey: 'openSettingsPanel', ns: 'SETTINGS_PANEL' },
    component: OptionsMenu,
    options: {},
    items: [
      {
        name: 'LanguageSettings',
        variant: 'panel',
        heading: { localeKey: 'languageSetting', ns: 'SETTINGS_PANEL' },
        underline: false,
        component: LanguageSettingsPanel,
        shouldRender: (props) => {
          const { __t } = props.options;
          const currRegionLocaleLangs = getRegionLocaleLangs(__t('locale', 'GENERAL'));
          return currRegionLocaleLangs?.showLangToggle;
        }
      },
      {
        name: 'AccessibilitySettings',
        variant: 'panel',
        heading: { localeKey: 'accessibilitySettings', ns: 'SETTINGS_PANEL' },
        underline: false,
        component: AccessibilitySettingsPanel,
      },
      {
        name: 'GameControls',
        variant: 'panel',
        heading: { localeKey: 'gameControls', ns: 'SETTINGS_PANEL' },
        underline: false,
        component: GameControlsPanel,
      },
      {
        name: 'VolumeControls',
        variant: 'widget',
        heading: { localeKey: 'volumeSetting', ns: 'SETTINGS_PANEL' },
        underline: false,
        component: VolumeControls,
        shouldRender: () => !isIOS(17.0, ">=")
      },
      {
        name: 'HappyMealHome',
        variant: 'link',
        heading: { localeKey: 'returnToHappyMealDotCom', ns: 'SETTINGS_PANEL' },
        href: { localeKey: 'hmButton.url', ns: 'GENERAL' },
        underline: false,
        shouldRender: (props: any) => props.returnToHappyMealDotCom !== '',
      },
      {
        name: 'AppHome',
        heading: { localeKey: 'appHome', ns: 'SETTINGS_PANEL' },
        variant: 'goto',
        targetPage: 0,
        underline: false,
      },
      {
        name: 'Onboarding',
        heading: { localeKey: 'onboardingVideo', ns: 'SETTINGS_PANEL' },
        variant: 'goto',
        targetPage: 'ONBOARDING',
        underline: false,
        onClick: (props: any) => {
          console.log("SETTINGS PANEL: props", props);
          if (document.querySelector('.game-wrapper')?.classList.contains('ONBOARDING')) {
            props.options.closeDialog();
          } else {
            props.options.goToPage('ONBOARDING');
            props.options.closeDialog();
            props.options.setIsPauseEnabled(false);
            props.options.setPlay(true);
          }
        }
      },
      {
        name: 'HowToPlay',
        variant: 'panel',
        heading: { localeKey: 'howToPlay', ns: 'SETTINGS_PANEL' },
        underline: false,
        component: HowToPlayPanel,
      },
      {
        name: 'GameMenu',
        heading: { localeKey: 'gameMenu', ns: 'SETTINGS_PANEL' },
        variant: 'goto',
        targetPage: 'LEVEL_SELECTION',
        underline: false,
      },
      // {
      //   name: 'ChangeCharacter',
      //   heading: { localeKey: 'selectCharacter', ns: 'SETTINGS_PANEL' },
      //   variant: 'goto',
      //   targetPage: 'CHARACTER_SELECTION',
      //   underline: true,
      // },
      // {
      //   name: 'CameraAccess',
      //   heading: { localeKey: 'cameraAccess', ns: 'SETTINGS_PANEL' },
      //   variant: 'goto',
      //   targetPage: 'CAMERA_ACCESS',
      //   underline: true,
      //   shouldRender: (props: any) =>
      //     !document.querySelector('main.market--mea'),
      // },
    ],
  },
};

export const componentConfig = {
  CircleButton: {
    defaultVariant: 'gradient',
    defaultColor: 'primary',
    defaultSize: 'md',
  },
  SettingsPanel: SettingsPanelConfig,
};
